import axios from "axios"

// paramsSerializer
const customParamsSerializer = (params: Record<string, any>): string => {
  const serachParams = new URLSearchParams()

  Object.keys(params).forEach((key) => {
    const value = params[key]

    if (Array.isArray(value)) {
      value.forEach((item) => serachParams.append(key, item))
    } else {
      serachParams.append(key, value)
    }
  })

  return serachParams.toString()
}

export const customAxios = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 60000,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
  paramsSerializer: customParamsSerializer,
})

export interface ErrorResponse {
  errorCode: number
  errorMessage: string
  data: object
  message: string
}
